import './MayaMayaAIBot.css';
import { useState } from "react";
import Message from "./Message";
import Input from "./Input";
import History from "./MayaMayaAIHistory";
import Clear from "./Clear";
import LoginForm from "./LoginForm";
import { jwtDecode } from "jwt-decode";
import Header from "../Header";

async function createStreamedCompletion(prompt, org_code, user_id) {
  return fetch("https://prompt-backend-dev-new-dyhwcve2htb3enh8.eastus-01.azurewebsites.net/api/mayamaya-lite/prompt-system", {

    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(
      {
        "org_code": org_code,
        "params": {
            prompt: prompt,
            user_id: user_id
        }
      }
    ),
  });
}


const isTokenExpired = (token) => {
  if (!token) return true;

  const { exp } = jwtDecode(token);
  if (!exp) return true;
  const currentTime = Math.floor(Date.now() / 1000);
  return exp < currentTime;
};

export default function MayaMayaAI({ name, userId, isModalOpen, isRegisterModalOpen, setIsRegisterModalOpen, setIsModalOpen, setIsLoggedIn, setUsername, setAccessKey, accessKey, remainingCredits }) {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const [orgCode, setOrgCode] = useState(null);
  const [user_id, setUserId] = useState(null);

  const handleAPIResponse = async () => {
    setLoading(true);
    const prompt = {
      role: "user",
      content: input,
    };

    setMessages([...messages, prompt]);

    const storedEmail = localStorage.getItem("email");
    const accessToken = localStorage.getItem("access_token");

        if (!accessToken) {
          throw new Error('You are not logged in. Please log in to access your profile.');
        }

    let res = "I don't have answer to your question, but will soon update myself with updated information";

    try {
      setMessages((messages) => {
        return [...messages, {}];
      });
      const response = await createStreamedCompletion(input, "-1000", storedEmail);
      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      reader.read().then(function processText({ done, value }) {
        if (done) {
          console.log('Stream complete');
          return;
        }
        
        setMessages((messages) => {
          const updatedMessages = [...messages];
          updatedMessages[updatedMessages.length - 1] = {
            role: "assistant",
            content: decoder.decode(value),
          };
          return updatedMessages;
        });
        return reader.read().then(processText);
      }).catch(err => {
        console.error('Error reading stream', err);
      });

    } catch(error) {
      console.log("Error in response", error);
    }

    setHistory((history) => [...history, { question: input, answer: res }]);
    setInput("");
    setLoading(false);
  }

  const clear = () => {
    setMessages([]);
    setHistory([]);
  };

  const handleLogin = (token, orgCode, user_id) => {
    setToken(token);
    setOrgCode(orgCode);
    setUserId(user_id);
  };

  return (
    <div className="MMAI-App">
      <Header 
        name={name}
        setIsLoggedIn={setIsLoggedIn}
        setUsername={setUsername}
        setAccessKey={setAccessKey}
        remainingCredits={remainingCredits}
        setIsRegisterModalOpen={setIsRegisterModalOpen}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        isRegisterModalOpen={isRegisterModalOpen}
      />
        <div className="MMAI-ChatContainer">
          <div className="MMAI-Sidebar">
            <h3 className="MMAI-Title">History</h3>
            <div className="MMAI-Content">
              {history.map((el, i) => {
                return (
                  <History
                    key={i}
                    question={el.question}
                    style={{ height: 'auto' }}
                    onClick={() =>
                      setMessages([
                        { role: "user", content: history[i].question },
                        { role: "assistant", content: history[i].answer },
                      ])
                    }
                  />
                );
              })}
            </div>
            <Clear onClick={clear} />
          </div>

          <div className="MMAI-Column">
            <h3 className="MMAI-Title">Chat Messages</h3>
            <div className="MMAI-Content">
              {loading ? 
              (<div>
                Loading......
              </div>) : messages.map((el, i) => (
                <Message key={i} role={el.role} content={el.content} />
              ))}
            </div>
            <Input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onClick={input ? handleAPIResponse : undefined}
              buttonName={"Send"}
            />
          </div>

        </div>
    </div>
  );
}